// based on https://htmldom.dev/drag-to-scroll/

const onMouseDown = (mouseDownEvent: MouseEvent, element: HTMLElement) => {
  let dragged = false;

  if (window.innerWidth < 1024) {
    return;
  }

  element.style.cursor = 'grabbing';
  element.style.userSelect = 'none';

  const position = {
    left: element.scrollLeft,
    x: mouseDownEvent.clientX,
  }

  const onMouseMove = (mouseMoveEvent: MouseEvent) => {
    const dx = mouseMoveEvent.clientX - position.x;
    element.scrollLeft = position.left - dx;
    dragged = true;
  }

  const onMouseClick = (e: Event): undefined | boolean => {
    element.style.cursor = 'grab';
    element.style.removeProperty('user-select');
    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseup', onMouseClick);
    if (dragged) {
      dragged = false;
      e.preventDefault();
      return false;
    } else {
      return undefined;
    }
  }

  document.addEventListener('click', onMouseClick);
  document.addEventListener('mousemove', onMouseMove);
};

document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('[drag-to-scroll]').forEach(element => {
    element.addEventListener('mousedown', (event) => onMouseDown(
      event as MouseEvent,
      element as HTMLElement
    ));
  });

  document.querySelectorAll('[disable-drag]').forEach((element) => {
    element.addEventListener('mousedown', (e) => {
      if (window.innerWidth < 1024) {
        return;
      }
      e.preventDefault();
      return false;
    });
  });

});

